import Alt from "alt";
var alt = new Alt();

export default alt